import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M533.333,560 L533.333,720 L240,720 L240.008,1173.33 L240.008,1173.33 L449.074,1386.67 L1470.93,1386.67 L1679.99,1173.33 L1680,720 L1386.67,720 L1386.67,560 L1738.67,560 C1794.63,560 1840,605.368 1840,661.333 L1840,661.333 L1840,1173.33 L1856,1173.33 C1891.35,1173.33 1920,1201.99 1920,1237.33 L1920,1856 C1920,1891.35 1891.35,1920 1856,1920 L64,1920 C28.6538,1920 0,1891.35 0,1856 L0,1237.33 C0,1201.99 28.6538,1173.33 64,1173.33 L80,1173.33 L80,661.333 C80,605.368 125.369,560 181.333,560 L533.333,560 Z M960,0 L1336.57,376.569 L1223.43,489.706 L1040,306.275 L1040,1173.33 L879.999,1173.33 L879.998,306.275 L696.568,489.706 L583.431,376.568 L960,0 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconUnarchiveSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconUnarchiveSolid, _Component);

  var _super = _createSuper(IconUnarchiveSolid);

  function IconUnarchiveSolid() {
    _classCallCheck(this, IconUnarchiveSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconUnarchiveSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconUnarchive",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconUnarchiveSolid.displayName = "IconUnarchiveSolid";
  return IconUnarchiveSolid;
}(Component);

IconUnarchiveSolid.glyphName = 'unarchive';
IconUnarchiveSolid.variant = 'Solid';
IconUnarchiveSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconUnarchiveSolid;
export { IconUnarchiveSolid };